import { Card } from '../components/ui/Card';
import { CodeSnippet } from '../components/ui/CodeSnippet';
import { TechSelector } from '../components/ui/TechSelector';

import { useAccountNumber } from '/src/hooks';
import { VideoPlayer } from '/src/components/VideoPlayer';
import { ListItem } from '../components/ui/ListItem';
import { SupportLink } from '../../_global/components/SupportLink';
import { SupportLinks } from '/src/support';
import WordpressPoster from '/src/features/installation/assets/wordpress-instructions-poster.jpg';
import WordpressVideo from '/src/features/installation/assets/wordpress-instructions.mp4';

export function WordpressInstructions({
  techOptions = [],
  selectedTechOption = null,
  onSelectTech,
  onContactDeveloper,
}) {
  const [accSegment1, accSegment2] = useAccountNumber(true);

  return (
    <Card className="max-w-[720px] w-full mt-5 mb-6">
      <div className="mb-4 flex w-full flex-col gap-3 md:flex-row md:items-center">
        <h2 className="flex-1 text-lg font-bold leading-9 text-black-pearl-500">Instructions</h2>
        <TechSelector techOptions={techOptions} selectedTechOption={selectedTechOption} onSelectTech={onSelectTech} />
      </div>

      <ol className="flex flex-col gap-4 mb-4">
        <ListItem number={1}>Log into your WordPress account.</ListItem>

        <ListItem number={2}>
          Click on <strong>Plugins</strong> along the left-hand side.
        </ListItem>

        <ListItem number={3}>
          Click on <strong>Add New</strong> in the submenu.
        </ListItem>

        <ListItem number={4}>
          At the top right hand corner, type in <strong>Crazy Egg</strong> within the <strong>Search plugins...</strong>{' '}
          input field.
        </ListItem>

        <ListItem number={5}>
          Find the Crazy Egg plugin.Click on <strong>Install Now</strong> and <strong>Activate.</strong>
        </ListItem>

        <ListItem number={6}>
          Click on <strong>Settings</strong> under the Crazy Egg Plugin. Or, click on the <strong>Crazy Egg</strong> tab
          along the left-hand side.
        </ListItem>

        <ListItem number={7}>
          Copy and paste the Crazy Egg tracking script below into the <strong>Your Tracking Script</strong> input field.
        </ListItem>
      </ol>

      <CodeSnippet
        code={`<script type="text/javascript" src="//script.crazyegg.com/pages/scripts/${accSegment1}/${accSegment2}.js" async="async"></script>`}
        showMailButton
        onMailButtonClick={onContactDeveloper}
      />

      <ol className="mt-4">
        <ListItem number={8}>
          Click on <strong>Save Changes.</strong>
        </ListItem>
      </ol>

      <p className="mt-10 text-base font-normal leading-6 text-black-pearl-500 mb-3">
        Watch this video to see these steps:
      </p>

      <VideoPlayer src={WordpressVideo} poster={WordpressPoster} label="WordPress installation video" />

      <div className="flex flex-col gap-1 mt-3">
        <SupportLink
          href={SupportLinks.install.wordpress}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Learn how to integrate with WordPress
        </SupportLink>
        <SupportLink
          href={SupportLinks.general.newSupportRequest}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Contact Support
        </SupportLink>
      </div>

      <p className="mt-3 text-black-pearl-500">
        Click on <strong>Check installation</strong> once you have installed Crazy Egg on your WordPress site.
      </p>
    </Card>
  );
}
